import Fetch, { V1, V3, V4 } from 'Util/fetcher';

const ON_REQUEST_MF_PAYMENT = 'ON_REQUEST_MF_PAYMENT';
const ON_REQUEST_MF_PAYMENT_FAILURE = 'ON_REQUEST_MF_PAYMENT_FAILURE';
const ON_REQUEST_MF_PAYMENT_SUCCESS = 'ON_REQUEST_MF_PAYMENT_SUCCESS';
const ON_RESET_ORDER = 'ON_RESET_ORDER';

function onRequestMfPayment() {
  return {
    type: ON_REQUEST_MF_PAYMENT,
  };
}
function onRequestMfPaymentSuccess(payload) {
  return {
    type: ON_REQUEST_MF_PAYMENT_SUCCESS,
    payload,
  };
}
function onRequestMfPaymentFailure(payload) {
  return {
    type: ON_REQUEST_MF_PAYMENT_FAILURE,
    payload,
  };
}

function onResetOrder() {
  return {
    type: ON_RESET_ORDER,
  };
}

export const onDoRequestResetMfPayment = () => (dispatch) => {
  dispatch(onRequestMfPaymentSuccess(null));
};

export const onDoRequestMfPayment = (payload) => (dispatch) => {
  dispatch(onRequestMfPayment());
  Fetch.post(`${V4}transactions/deposits/create-by-theme/`, payload)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestMfPaymentSuccess(resp.json));
      } else {
        dispatch(onRequestMfPaymentFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestMfPaymentFailure(error.message));
    });
};

export const onDoResetOrder = () => (dispatch) => {
  dispatch(onResetOrder());
};

const ON_REQUEST_MF_WITHDRAW = 'ON_REQUEST_MF_WITHDRAW';
const ON_REQUEST_MF_WITHDRAW_FAILURE = 'ON_REQUEST_MF_WITHDRAW_FAILURE';
const ON_REQUEST_MF_WITHDRAW_SUCCESS = 'ON_REQUEST_MF_WITHDRAW_SUCCESS';
function onRequestMfWithdraw() {
  return {
    type: ON_REQUEST_MF_WITHDRAW,
  };
}
function onRequestMfWithdrawSuccess(payload) {
  return {
    type: ON_REQUEST_MF_WITHDRAW_SUCCESS,
    payload,
  };
}
function onRequestMfWithdrawFailure(payload) {
  return {
    type: ON_REQUEST_MF_WITHDRAW_FAILURE,
    payload,
  };
}
export const onDoRequestResetMfWithdraw = () => (dispatch) => {
  dispatch(onRequestMfWithdrawSuccess(null));
};
export const onDoRequestMfWithdraw = (payload) => (dispatch) => {
  dispatch(onRequestMfWithdraw());
  Fetch.post(`${V4}transactions/withdrawals/withdraw-by-theme/`, payload, false, false)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestMfWithdrawSuccess(resp.json));
      } else {
        dispatch(onRequestMfWithdrawFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestMfWithdrawFailure(error.message));
    });
};

// ---------------------------------------------------//
// ----------------DEPOSIT ESTIMATION-----------------//
// ---------------------------------------------------//
const ON_REQUEST_DEPOSIT_ESTIMATION = 'ON_REQUEST_DEPOSIT_ESTIMATION';
const ON_REQUEST_DEPOSIT_ESTIMATION_SUCCESS = 'ON_REQUEST_DEPOSIT_ESTIMATION_SUCCESS';
const ON_REQUEST_DEPOSIT_ESTIMATION_FAILURE = 'ON_REQUEST_DEPOSIT_ESTIMATION_FAILURE';

function onRequestDepositEstimation() {
  return {
    type: ON_REQUEST_DEPOSIT_ESTIMATION,
  };
}
function onRequestDepositEstimationSuccess(payload) {
  return {
    type: ON_REQUEST_DEPOSIT_ESTIMATION_SUCCESS,
    payload,
  };
}
function onRequestDepositEstimationFailure(payload) {
  return {
    type: ON_REQUEST_DEPOSIT_ESTIMATION_FAILURE,
    payload,
  };
}

export const onDoRequestDepositEstimation = () => (dispatch) => {
  dispatch(onRequestDepositEstimation());
  Fetch.get(`${V4}transactions/deposits/estimation-process/`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestDepositEstimationSuccess(resp.json));
      } else {
        dispatch(onRequestDepositEstimationFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestDepositEstimationFailure(error.message));
    });
};

// Withdrawl Estimation
const ON_REQUEST_WITHDRAWL_ESTIMATION = 'ON_REQUEST_WITHDRAWL_ESTIMATION';
const ON_REQUEST_WITHDRAWL_ESTIMATION_SUCCESS = 'ON_REQUEST_WITHDRAWL_ESTIMATION_SUCCESS';
const ON_REQUEST_WITHDRAWL_ESTIMATION_FAILURE = 'ON_REQUEST_WITHDRAWL_ESTIMATION_FAILURE';

function onRequestWithdrawlEstimation() {
  return {
    type: ON_REQUEST_WITHDRAWL_ESTIMATION,
  };
}
function onRequestWithdrawlEstimationSuccess(payload) {
  return {
    type: ON_REQUEST_WITHDRAWL_ESTIMATION_SUCCESS,
    payload,
  };
}
function onRequestWithdrawlEstimationFailure(payload) {
  return {
    type: ON_REQUEST_WITHDRAWL_ESTIMATION_FAILURE,
    payload,
  };
}

export const onDoRequestWithdrawlEstimation = (id) => (dispatch) => {
  dispatch(onRequestWithdrawlEstimation());
  Fetch.get(`${V3}mutualfund/transactions/withdrawal/estimation-process?fund_id=${id}`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestWithdrawlEstimationSuccess(resp.json));
      } else {
        dispatch(onRequestWithdrawlEstimationFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestWithdrawlEstimationFailure(error.message));
    });
};

// withdrawl account
const ON_REQUEST_WITHDRAWL_ACCOUNT = 'ON_REQUEST_WITHDRAWL_ACCOUNT';
const ON_REQUEST_WITHDRAWL_ACCOUNT_SUCCESS = 'ON_REQUEST_WITHDRAWL_ACCOUNT_SUCCESS';
const ON_REQUEST_WITHDRAWL_ACCOUNT_FAILURE = 'ON_REQUEST_WITHDRAWL_ACCOUNT_FAILURE';

function onRequestWithdrawlAccount() {
  return {
    type: ON_REQUEST_WITHDRAWL_ACCOUNT,
  };
}
function onRequestWithdrawlAccountSuccess(payload) {
  return {
    type: ON_REQUEST_WITHDRAWL_ACCOUNT_SUCCESS,
    payload,
  };
}
function onRequestWithdrawlAccountFailure(payload) {
  return {
    type: ON_REQUEST_WITHDRAWL_ACCOUNT_FAILURE,
    payload,
  };
}

export const onDoRequestWithdrawlAccount = (id) => (dispatch) => {
  dispatch(onRequestWithdrawlAccount());
  Fetch.get(`${V1}mutualfund/user/withdrawal-account/?fund_id=${id}`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestWithdrawlAccountSuccess(resp.json));
      } else {
        dispatch(onRequestWithdrawlAccountFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestWithdrawlAccountFailure(error.message));
    });
};
// ---------------------------------------------------//
// ---------------------PAY MF BILL-------------------//
// ---------------------------------------------------//
const ON_PAY_MF_BILL = 'ON_PAY_MF_BILL';
const ON_PAY_MF_BILL_SUCCESS = 'ON_PAY_MF_BILL_SUCCESS';
const ON_PAY_MF_BILL_FAILURE = 'ON_PAY_MF_BILL_FAILURE';
const ON_RESET_BILL = 'ON_RESET_BILL';

function onPayMfBill() {
  return {
    type: ON_PAY_MF_BILL,
  };
}
function onPayMfBillSuccess(payload) {
  return {
    type: ON_PAY_MF_BILL_SUCCESS,
    payload,
  };
}
function onPayMfBillFailure(payload) {
  return {
    type: ON_PAY_MF_BILL_FAILURE,
    payload,
  };
}

export const onDoPayMfBill = (payload) => (dispatch) => {
  dispatch(onPayMfBill());
  Fetch.post(`${V1}rdn/payment/mutual-fund/`, payload)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onPayMfBillSuccess(resp.json));
      } else {
        dispatch(onPayMfBillFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onPayMfBillFailure(error.message));
    });
};

export const onDoResetBill = () => ({
  type: ON_RESET_BILL,
});

const ON_RESET_PREV_DATA = 'ON_RESET_PREV_DATA';
function onResetToPrevData(payload) {
  return {
    type: ON_RESET_PREV_DATA,
    payload,
  };
}
export const onDoResetToPrevData = (payload) => (dispatch) => {
  dispatch(onResetToPrevData(payload));
};

const INITIAL_STATE = {
  paymentLoading: false,
  paymentData: null,
  paymentError: null,

  withdrawLoading: false,
  withdrawData: null,
  withdrawError: null,

  depositEstimationLoading: false,
  depositEstimationData: null,
  depositEstimationError: null,

  withdrawlEstimationLoading: false,
  withdrawlEstimationData: null,
  withdrawlEstimationError: null,

  withdrawlAccountLoading: false,
  withdrawlAccountData: null,
  withdrawlAccountError: null,

  payMfBillLoading: false,
  payMfBillData: null,
  payMfBillError: null,
};

const mfOrder = (state = INITIAL_STATE, { type, payload } = {}) => {
  switch (type) {
    case ON_RESET_PREV_DATA:
      return {
        paymentData: payload,
        paymentError: null,
      };
    case ON_REQUEST_MF_PAYMENT:
      return {
        ...state,
        paymentLoading: true,
        paymentData: null,
        paymentError: null,
      };
    case ON_REQUEST_MF_PAYMENT_SUCCESS:
      return {
        ...state,
        paymentLoading: false,
        paymentData: payload,
        paymentError: null,
      };
    case ON_REQUEST_MF_PAYMENT_FAILURE:
      return {
        ...state,
        paymentLoading: false,
        paymentData: null,
        paymentError: payload,
      };

    case ON_REQUEST_MF_WITHDRAW:
      return {
        ...state,
        withdrawLoading: true,
        withdrawData: null,
        withdrawError: null,
      };
    case ON_REQUEST_MF_WITHDRAW_SUCCESS:
      return {
        ...state,
        withdrawLoading: false,
        withdrawData: payload,
        withdrawError: null,
      };
    case ON_REQUEST_MF_WITHDRAW_FAILURE:
      return {
        ...state,
        withdrawLoading: false,
        withdrawData: null,
        withdrawError: payload,
      };
    case ON_REQUEST_DEPOSIT_ESTIMATION:
      return {
        depositEstimationLoading: true,
        depositEstimationData: null,
        depositEstimationError: null,
      };
    case ON_REQUEST_DEPOSIT_ESTIMATION_SUCCESS:
      return {
        depositEstimationLoading: false,
        depositEstimationData: payload,
        depositEstimationError: null,
      };
    case ON_REQUEST_DEPOSIT_ESTIMATION_FAILURE:
      return {
        depositEstimationLoading: false,
        depositEstimationData: null,
        depositEstimationError: payload,
      };
    case ON_REQUEST_WITHDRAWL_ESTIMATION:
      return {
        withdrawlEstimationLoading: true,
        withdrawlEstimationData: null,
        withdrawlEstimationError: null,
      };
    case ON_REQUEST_WITHDRAWL_ESTIMATION_SUCCESS:
      return {
        ...state,
        withdrawlEstimationLoading: false,
        withdrawlEstimationData: payload,
        withdrawlEstimationError: null,
      };
    case ON_REQUEST_WITHDRAWL_ESTIMATION_FAILURE:
      return {
        withdrawlEstimationLoading: false,
        withdrawlEstimationData: null,
        withdrawlEstimationError: payload,
      };
    case ON_REQUEST_WITHDRAWL_ACCOUNT:
      return {
        withdrawlAccountLoading: true,
        withdrawlAccountData: null,
        withdrawlAccountError: null,
      };
    case ON_REQUEST_WITHDRAWL_ACCOUNT_SUCCESS:
      return {
        ...state,
        withdrawlAccountLoading: false,
        withdrawlAccountData: payload,
        withdrawlAccountError: null,
      };
    case ON_REQUEST_WITHDRAWL_ACCOUNT_FAILURE:
      return {
        withdrawlAccountLoading: false,
        withdrawlAccountData: null,
        withdrawlAccountError: payload,
      };
    case ON_RESET_ORDER:
      return {
        ...state,
        paymentData: null,
        paymentError: null,
      };
    case ON_PAY_MF_BILL:
      return {
        payMfBillLoading: true,
        payMfBillData: null,
        payMfBillError: null,
      };
    case ON_PAY_MF_BILL_SUCCESS:
      return {
        payMfBillLoading: false,
        payMfBillData: payload,
        payMfBillError: null,
      };
    case ON_PAY_MF_BILL_FAILURE:
      return {
        payMfBillLoading: false,
        payMfBillData: null,
        payMfBillError: payload,
      };
    case ON_RESET_BILL:
      return {
        payMfBillLoading: false,
        payMfBillData: null,
        payMfBillError: null,
      };
    default:
      return state;
  }
};

export default mfOrder;
